import { useSyncExternalStore } from "react";
import { liveSocket, type PositionTick } from "@/lib/live";

/**
 * M31 — the live per-position P/L book, read straight off the socket store (the quote
 * pattern): a per-second frame through the query cache would re-render the whole tree.
 * The snapshot is replaced per frame, so consumers re-render exactly once per frame.
 */
export function usePositionTicks(): ReadonlyMap<string, PositionTick> {
  return useSyncExternalStore(
    (onChange) => liveSocket.subscribePositions(onChange),
    () => liveSocket.getPositionTicks(),
  );
}
